import React, { useEffect, useState } from "react";
import { useParams, useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { Eye, Pencil } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export function PageContent({ slug, preview = false }) {
  const [p, setP] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    setP(null); setErr(false);
    api.get(`/pages/view/${slug}`, { params: preview ? { preview: 1 } : {} }).then((r) => setP(r.data)).catch(() => setErr(true));
  }, [slug, preview]);
  if (err) return <div className="max-w-3xl mx-auto py-16 text-center text-slate-500" data-testid="page-not-found">This page isn't available.</div>;
  if (!p) return <div className="max-w-3xl mx-auto py-16 text-center text-slate-400">Loading…</div>;
  return (
    <article className="max-w-3xl mx-auto tr-animate-in" data-testid="managed-page">
      <h1 className="font-display text-3xl sm:text-4xl font-bold text-slate-900 leading-tight mb-6" data-testid="managed-page-title">{p.title}</h1>
      <div className="tr-page" data-testid="managed-page-body" dangerouslySetInnerHTML={{ __html: p.body || "" }} />
      <p className="text-xs text-slate-400 mt-10 pt-4 border-t border-slate-100">Last updated {new Date(p.updated_at).toLocaleDateString()}</p>
    </article>);
}

export default function ManagedPage() {
  const { slug } = useParams();
  const [sp] = useSearchParams();
  const { isSuper } = useAuth();
  const preview = sp.get("preview") === "1" && isSuper;
  const id = sp.get("id");
  return (
    <div>
      {preview && (
        <div className="max-w-3xl mx-auto mb-6 flex flex-wrap items-center justify-between gap-2 rounded-lg border border-amber-200 bg-amber-50 px-4 py-2 text-sm text-amber-800" data-testid="page-preview-banner">
          <span className="inline-flex items-center gap-2"><Eye className="w-4 h-4" />Preview — this is how the page looks to people who can see it.</span>
          {id && <Link to={`/admin/pages/${id}`} className="inline-flex items-center gap-1 font-medium text-[#006090] hover:underline" data-testid="page-preview-edit"><Pencil className="w-3.5 h-3.5" />Back to editor</Link>}
        </div>)}
      <PageContent slug={slug} preview={preview} />
    </div>);
}
